import './CancelledInterview_Page.css';
import Icons_Repository from '../Icons/Icons_Repository';

function sanitizeForAttribute(value: string) {
  // Basic defensive encoding for special characters in HTML attributes
  return value
    ?.replace(/&/g, '&amp;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#x27;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;');
}

function sanitizeForText(value: string) {
  // Basic defensive encoding for text content
  return value
    ?.replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;');
}


function CancelledInterview_Page({recruiterEmail, recruiterName}:any){
    const safeEmail = sanitizeForAttribute(recruiterEmail || '');
    const safeName = sanitizeForText(recruiterName || '');
    return (
        <div className='cancelled-page-container'>

        
            <div className="cancelled-page">
                <div className="cancelled-card">
                    <div className="cancelled-header">
                        <div className='cancelled-calendar-icon'>
                            <Icons_Repository iconName='calendar' />
                        </div>
                        <div className="cancelled-title">
                            <h2>Interview Canceled</h2>
                        </div>
                        {/* <div className='calendar-icon'>
                            <Icons_Repository iconName='calendar' />
                        </div>
                        <h2 className="cancelled-title">Interview Cancelled</h2> */}
                    </div>
                    <div className='cancelled-body'>
                        <div className='cancelled-body-text'>
                            Your interview has been canceled. If you have any questions, please contact your recruiter at {' '}
                            <a
                                href={`mailto:${safeEmail}`}
                                className="support-email-link"
                            >
                                {safeName}
                            </a>
                        </div>
                    </div>
                    {/* <p className="cancelled-text">
                        Your scheduled interview has been successfully cancelled. 
                    </p>

                    <p className="cancelled-subtext">
                        A confirmation email has been sent to your mail. Feel free to reschedule anytime.
                    </p> */}

                </div>
            </div>
        </div>
    )
}
export default CancelledInterview_Page